<div class="d-flex justify-content-center center px-2 py-3">

  <app-text-field
    class="w-100"
    [type]="'default'"
    (input)="x_data.input"
    [label]="x_data.label"
    [(ngModel)]="x_data.input"
    (keydown.enter)="save()"
  ></app-text-field>

</div>

<mat-divider></mat-divider>

<div class="bg-light d-flex justify-content-around gap-2" mat-dialog-actions>
  <app-button
    (onChangeClick)="onNoClick()"
    [customClass]="'bg-danger'">
    {{ x_data.no ?? 'cancel' | translate }}
  </app-button>
  <app-button
    [disabled]="!!this.x_data.input && !this.x_data.input?.trim()"
    (onChangeClick)="save()">
    {{ x_data.yes ?? ('save' | translate) }}
  </app-button>
</div>
